import { unescape as unescapeHTML } from 'html-escaper'
import React from 'react'

import styled from 'styled-components'
import { black } from 'uiComponents/constants/colors'

interface BrowseSeoText {
  categoryName?: string
  seoText?: string
  seoKeyword?: string
  className?: string
  hideSeoTitle?: boolean
}

const Title = styled.h1`
  font-weight: 600;
  color: ${black};
  font-size: 20px;
  line-height: 24px;
  margin: 0 0 15px;
`

function generateTitle({
  seoTextContainsH1,
  hideSeoTitle,
  categoryName,
  seoKeyword,
}: {
  hideSeoTitle: boolean
  seoTextContainsH1?: boolean
  categoryName?: string
  seoKeyword?: string
}) {
  if (seoTextContainsH1 || hideSeoTitle) {
    return null
  }

  const title = seoKeyword || categoryName

  const processedTitle = title ? unescapeHTML(title) : ''

  return <Title>{processedTitle}</Title>
}

const TextWrapper = styled.div`
  color: ${black};

  h1 {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin: 0 0 15px;
  }

  h2 {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }

  p {
    margin: 5px 0 15px;
    font-size: 12px;
  }

  ul {
    margin: 5px 0 15px;
  }

  li {
    margin: 5px 0 15px;
  }

  a {
    text-decoration: underline;
  }

  i,
  em {
    font-style: italic;
  }
`

function SeoText({
  categoryName,
  seoKeyword,
  seoText = '',
  className = '',
  hideSeoTitle = false,
}: BrowseSeoText) {
  const seoTextContainsH1 = seoText ? seoText.includes('<h1') : false
  const unescapedSeoText = seoText ? unescapeHTML(seoText) : ''

  return (
    <div className={className}>
      {generateTitle({
        seoTextContainsH1,
        categoryName,
        seoKeyword,
        hideSeoTitle,
      })}
      <TextWrapper dangerouslySetInnerHTML={{ __html: unescapedSeoText }} />
    </div>
  )
}

export default SeoText
